import { render, staticRenderFns } from "./ChatLogItem.vue?vue&type=template&id=81366f40"
import script from "./ChatLogItem.vue?vue&type=script&lang=js"
export * from "./ChatLogItem.vue?vue&type=script&lang=js"
import style0 from "./ChatLogItem.vue?vue&type=style&index=0&id=81366f40&prod&lang=css"
import style1 from "./ChatLogItem.vue?vue&type=style&index=1&id=81366f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports